import React from 'react'
import styled from 'styled-components'
import MainContent from '../components/AssignmentsGalleryView/MainContent'
import ThumbsNavLayout from '../components/AssignmentsGalleryView/ThumbsNavLayout'
import TopHeader from '../components/AssignmentsGalleryView/TopHeader'

const GalleryView = ({ rightNavbarVisible, setRightNavbarVisible }) => {
  const [thumbsviewNavbarMinified, setthumbsviewNavbarMinified] =
    React.useState(true)

  setRightNavbarVisible(false) // as rightNavbar is nomore in assignmentExpandedView

  return (
    <Pagewrapper width='100%'>
      <ThumbsNavLayout
        // rightNavbarMinified={rightNavbarMinified}
        // leftNavbarMinified={leftNavbarMinified}
        thumbsviewNavbarMinified={thumbsviewNavbarMinified}
        setthumbsviewNavbarMinified={setthumbsviewNavbarMinified}
      />

      <Wrapper width='100%' gap='1%'>
        <TopHeader />
        <MainContent />
      </Wrapper>
    </Pagewrapper>
  )
}

const Pagewrapper = styled.div`
  display: flex;
  width: ${(props) => props.width};
  overflow: hidden;
  /* height: 100%; */
  /* position: relative; */
  position: absolute;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width};
  height: 100%;
  max-width: 2400px;
  background-color: #fbfbfb;

  gap: ${(props) => props.gap};
  margin-left: ${(props) => props.marginLeft};
  height: auto;

  overflow: hidden;
  /* padding: 15px 10px; */
  padding: 2%;
  position: relative;
  z-index: 0;

  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
`

export default GalleryView
